"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineHeightMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
var _addSuffix = require("../util/addSuffix");
/** @mixin lineHeightMixin */
/**
 * Get the line height for the given font type.
 *
 * @example
 * import { lineHeightMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${lineHeightMixin('h1')}
 * `;
 *
 * <Component>h1 line height</Component>
 *
 * @method
 * @param {string} fontType - The `fontType` key for the `lineHeights` object.
 * @param {function} [callback] - An optional callback that will be called with an object with the
 *     line height value and suffix properties. The value returned from the function will be
 *     inserted.
 * @return {Interpolation}
 */
var lineHeightMixin = function lineHeightMixin(fontType, callback) {
  return (0, _styledToken.default)({
    lineHeights: 'lineHeights',
    suffix: 'defaultUnit'
  }, function (_ref) {
    var lineHeights = _ref.lineHeights,
      suffix = _ref.suffix;
    var value = lineHeights && lineHeights[fontType];
    if (typeof callback === 'function') {
      return callback({
        value: value,
        suffix: suffix
      });
    }
    return (0, _addSuffix.addSuffix)(value, suffix);
  });
};
exports.lineHeightMixin = lineHeightMixin;